import { toPriceCurrency, toProperCase } from '@/utils/helpers';

export const MAXPLUS_PLAN_STANDARD_NAME = 'standard';
export const MAXPLUS_PLAN_PREMIUM_NAME = 'premium';
export const MAXPLUS_PLAN_STANDARD_PRICE = 5;
export const MAXPLUS_PLAN_PREMIUM_PRICE = 7;

export const getMaxplusPlanPriceByType = type => {
  switch (type) {
    case MAXPLUS_PLAN_STANDARD_NAME:
      return MAXPLUS_PLAN_STANDARD_PRICE;
    case MAXPLUS_PLAN_PREMIUM_NAME:
      return MAXPLUS_PLAN_PREMIUM_PRICE;
    default:
      return 0;
  }
};

export const MAX_PLUS_SUBSCRIPTIONS_STATUSES = [
  { value: '', label: 'All' },
  { value: 'active', label: 'Active' },
  { value: 'grace', label: 'Grace' },
  { value: 'pending', label: 'Pending' },
  { value: 'expired', label: 'Expired' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'refunded', label: 'Refunded' },
  { value: 'failed', label: 'Failed' }
];

export const BONUS_FUNDS_TYPES = [
  { value: 'bonus_funds', label: 'Bonus Funds' },
  { value: 'champion_funds', label: 'Champion Funds' },
  { value: 'free_credit_bonus', label: 'Welcome Bonus' }
];

export const USAGE_TYPES = {
  allocation_sent: 'Allocation Sent',
  allocation_received: 'Allocation Received',
  allocation_reversed: 'Allocation Reversed',
  email_send: 'Email Sent',
  email_response: 'Email Response',
  sms_send: 'SMS Sent',
  sms_receive: 'SMS Received',
  mms_send: 'MMS Sent',
  mms_receive: 'MMS Received',
  ai_token: 'AI Tokens',
  ai_email_message: 'AI Email Message',
  ai_email_review: 'AI Email Review',
  email_validation: 'Email Validation',
  phone_validation: 'Phone Validation',
  test_usage: 'Test Usage',
  manual_deduction: 'Manual Deduction',
  auto_refill_triggered: 'Auto Refill',
  auto_refill_failed: 'Auto Refill Failed',
  auto_refill_blocked: 'Auto Refill Blocked',
  manual_topup: 'Manual Top-up',
  free_credit_bonus: 'Welcome Bonus',
  bonus_funds: 'Bonus Funds',
  champion_funds: 'Champion Funds',
  phone_number_purchase: 'Phone Number Puchase',
  reclaim: 'Reclaim',
  reset_balance: 'Reset Balance',
  sms_balance_conversion: 'SMS Balance Conversion',
  email_send_allowance: 'Email Send Allowance'
};

export const getMaxplusPlanPriceByTypeLabel = type => `$${toPriceCurrency(getMaxplusPlanPriceByType(type))}`;

export const getInvoiceType = invoice => {
  if (invoice.txn_type === 'subscription') return `MAX+ ${toProperCase(invoice.invoice_type)}`;

  return USAGE_TYPES[invoice.invoice_type] || invoice.invoice_type;
};

export const getInvoiceStatus = status => {
  switch (status) {
    case 'charged':
      return 'Paid';
    case 'pending':
      return 'Processing';
    case 'failed':
      return 'Failed';
    case 'active':
      return 'Active';
    case 'cancelled':
      return 'Cancelled';
    case 'refunded':
      return 'Refunded';
    case 'expired':
      return 'Expired';
    case 'grace':
      return 'Grace';
    default:
      return status || 'Completed';
  }
};

export const getMaxplusSubscriptionStatus = status => {
  switch (status) {
    case 'active':
      return 'Active';
    case 'grace':
      return 'Grace';
    case 'pending':
      return 'Pending';
    case 'expired':
      return 'Expired';
    case 'cancelled':
      return 'Cancelled';
    case 'refunded':
      return 'Refunded';
    case 'failed':
      return 'Failed';
    default:
      return status;
  }
};
